import { PanelCategory, PanelConfig } from '@helios/panel-base'
import { ReconDashboardPanelComponent } from './lib/recon-dashboard-panel.component'
import { ReconDashboardKey } from './panel-key'

export const ReconDashboardPanelConfig: PanelConfig = {
  key: ReconDashboardKey,
  title: 'Recon Dashboard',
  description: 'Combined Reconciliation Insights',
  category: PanelCategory.SUPPLEMENTARY,
  panelComponent: ReconDashboardPanelComponent,
  accessPermission: 'accessReconDashboardPanel',
  isExternal: true,
}
